export default class Validator {
    constructor() {
        this.decimalSeparator = ',';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-9])|([1-4][0-9])|50|51|52)[0-9]{3}$/));
    }
}
